import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'cbre-spinner-loading-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatProgressSpinnerModule],
  styleUrls: ['./spinner-loading-indicator.component.scss'],
  template: `
    <div class="miq-sli__container" [ngClass]="{ 'miq-sli__container--full-page': fullPage }">
      <div class="miq-sli__background"></div>
      <div class="miq-sli__spinner-wrapper">
        <mat-spinner [diameter]="diameter" class="miq-sli__spinner"></mat-spinner>
        <div *ngIf="description != null" class="miq-sli__spinner-label">{{ description }}</div>
      </div>
    </div>
  `,
})
export class SpinnerLoadingIndicatorComponent {
  @Input() description: string = null;
  @Input() fullPage = false;
  @Input() diameter = 24;
}
